import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

// Alert component wrapped with forwardRef for proper MUI behavior
const Alert = React.forwardRef((props, ref) => (
  <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
));

export const SnackBarComponent = ({ open, message, severity, onClose }) => (
  <Snackbar
    open={open}
    autoHideDuration={4000}
    onClose={onClose}
    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}  // Position at top center
  >
    <Alert onClose={onClose} severity={severity || 'info'} sx={{ width: '100%' }}>
      {message}
    </Alert>
  </Snackbar>
);
